import React, { Fragment, Component } from 'react'
import axios from 'axios'
import { getApiBaseUrl } from '../utils/api';
import SiteFooter from '../components/SiteFooter';
import { loanFormOptions, loanTypes } from '../content/siteContent';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const loanThumbs = [
    'assets/images/site/loan-home.jpg',
    'assets/images/site/loan-against-property.jpg',
    'assets/images/site/loan-personal.jpg',
    'assets/images/site/why-business-services.jpg',
    'assets/images/site/loan-vehicle.jpg',
    'assets/images/site/loan-startup.jpg',
    'assets/images/site/loan-builder.jpg',
];

class Loan extends Component {
    
    constructor(){
        super();
        this.state={
            name: '',
            mobileno: '',
            email:'',
            loantype:''
        }
    }

    onChangeInput = (e) => {
        const re = /^[0-9\b]+$/;
        if(e.target.name === "name"){
          this.setState({
              name: e.target.value
          });
        } else if(e.target.name === "mobileno" && (re.test(e.target.value) || e.target.value === "") && e.target.value.length <= 10){
             this.setState({
                 mobileno: e.target.value
             });
         } else if(e.target.name === "email"){
             this.setState({
                 email: e.target.value
             });
         } else if(e.target.name === "loantype"){
             this.setState({
                 loantype: e.target.value
             });
         }
    }
   
    onSendMessage = async () => {
        let enquiryDetail = {
            Name: this.state.name,
            MobileNumber: this.state.mobileno,
            EmailId: this.state.email,
            LoanType: this.state.loantype
        };
        if(enquiryDetail.Name.length == 0 || enquiryDetail.MobileNumber.length == 0 || enquiryDetail.EmailId.length == 0){
            toast.warning("Please enter Name, Mobile Number and EmailId");
            return;
        }
        await axios.post(`${getApiBaseUrl()}/hj-enquiry/createLoanEnq`,enquiryDetail)
            .then((res) => {
                toast.success("Loan Enquiry saved Successfully! Our executive will contact you as soon as possible.");
                this.clearForm();
            }).catch((error) => {
                console.log(error);
            });
    }
    clearForm = async () =>{
        this.setState({
            name: '',
            mobileno: '',
            email:'',
            loantype:''
        })
    }
    render(){
        return (
            <Fragment>
                <ToastContainer />
                <div className="boxed_wrapper ltr">
                    {/* Mobile Menu  */}
                    <div className="mobile-menu">
                        <div className="menu-backdrop"></div>
                        <div className="close-btn"><i className="fas fa-times"></i></div>

                        <nav className="menu-box">
                            <div className="nav-logo"><a href="/"><img src="assets/images/logo-4.png" alt="H.J. Enterprises" title=""/></a></div>
                            <div className="menu-outer">{/*Here Menu Will Come Automatically Via Javascript / Same Menu as in Header*/}</div>
                        </nav>
                    </div>{/* End Mobile Menu */}
                    {/* page-title */}
                    <section className="page-title centred">
                        <div className="bg-layer" style={{backgroundImage: "url(assets/images/background/page-title.jpg)"}}></div>
                        <div className="pattern-layer">
                            <div className="pattern-1" style={{backgroundImage: "url(assets/images/shape/shape-18.png)"}}></div>
                            <div className="pattern-2" style={{backgroundImage: "url(assets/images/shape/shape-17.png)"}}></div>
                        </div>
                        <div className="auto-container">
                            <div className="content-box">
                                <h1>Our Financial Services</h1>
                            </div>
                        </div>
                    </section>

                    {/* faq-section end */}
                    {/* career-section */}
                    <section className="career-section pt_50 pb_50">
                        <div className="bg-layer" style={{backgroundImage: "url(assets/images/background/career-bg.jpg)"}}></div>
                        <div className="auto-container">
                            <div className="sec-title centred mb_70">
                                <h2>Types of Loans We Assist With</h2>
                            </div>
                            <div className="inner-container">
                                {loanTypes.map((loan, index) => (
                                <div className="career-block-one" key={loan.title}>
                                    <div className="inner-box">
                                        <div className="author-box">
                                            <div className="text-box">
                                                <h3>{loan.title}</h3>
                                                <span className="designation">{loan.summary}</span>
                                                {loan.detail && <p className="loan-detail-note">{loan.detail}</p>}
                                                {(loan.lists || [{ label: loan.pointsLabel, points: loan.points }]).some((list) => list.points.length > 0) && (
                                                    <div className="loan-detail-lists">
                                                        {(loan.lists || [{ label: loan.pointsLabel, points: loan.points }])
                                                            .filter((list) => list.points.length > 0)
                                                            .map((list, listIndex) => (
                                                                <div className={`loan-detail-list${list.wide ? ' full' : ''}`} key={`${loan.title}-${listIndex}`}>
                                                                    {list.label && <p><strong>{list.label}</strong></p>}
                                                                    <ul>
                                                                        {list.points.map((point) => <li key={point}>{point}</li>)}
                                                                    </ul>
                                                                </div>
                                                            ))}
                                                    </div>
                                                )}
                                            </div>
                                            <figure className="thumb-box"><img src={loanThumbs[index]} alt={loan.title}/></figure>
                                        </div>
                                    </div>
                                </div>
                                ))}


                            </div>
                        </div>
                    </section>
                    {/* career-section end */}

                    {/* faq-form-section */}
                    <section className="faq-form-section pt_50 pb_120">
                        <div className="auto-container" id="register-form-loan">
                            <div className="sec-title mb_70 centred">
                                <h2>Register Form</h2>
                            </div>
                            <div className="form-inner">
                                <div className="row clearfix">
                                    <div className="col-lg-12 col-md-12 col-sm-12 form-group">
                                        <input 
                                            type="text" 
                                            name="name" 
                                            placeholder="Your Full Name" 
                                            required
                                            onChange={this.onChangeInput}
                                            value={this.state.name}
                                        />
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                                        <input 
                                            type="text" 
                                            name="mobileno" 
                                            placeholder="Mobile Number" 
                                            required
                                            onChange={this.onChangeInput}
                                            value={this.state.mobileno}
                                        />
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                                        <input 
                                            type="email" 
                                            name="email" 
                                            placeholder="Your Email" 
                                            required
                                            onChange={this.onChangeInput}
                                            value={this.state.email}
                                        />
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 form-group">
                                        <select
                                            name="loantype"
                                            onChange={this.onChangeInput}
                                            value={this.state.loantype}
                                            required
                                        >
                                            <option value="">Select loan type</option>
                                            {loanFormOptions.map((option) => (
                                                <option key={option} value={option}>{option}</option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="col-lg-12 col-md-12 col-sm-12 form-group message-btn centred">
                                        <button type="submit" className="theme-btn btn-one" onClick={this.onSendMessage}>Send Message</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* faq-form-section end */}
                    {/* main-footer */}
                    <SiteFooter />
                    {/* main-footer end */}
                    {/*Scroll to top*/}
                    <div className="scroll-to-top">
                        <div>
                            <div className="scroll-top-inner">
                                <div className="scroll-bar">
                                    <div className="bar-inner"></div>
                                </div>
                                <div className="scroll-bar-text">Go To Top</div>
                            </div>
                        </div>
                    </div>
                    {/* Scroll to top end */}

                </div>
                
            </Fragment >
        )
    }
}

export default Loan;